import { render, staticRenderFns } from "./fixShopSort.vue?vue&type=template&id=76820d74&scoped=true&"
import script from "./fixShopSort.vue?vue&type=script&lang=js&"
export * from "./fixShopSort.vue?vue&type=script&lang=js&"
import style0 from "./fixShopSort.vue?vue&type=style&index=0&id=76820d74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76820d74",
  null
  
)

export default component.exports